<template>
  <div class="product">
    <!-- <Header name="Products"></Header> -->
    <TopHP title="Penetrate Every Aspect of Dropshipping"
      subtitle="The best dropshipping tool for e-commerce, everything you need to scale your business is here. Product selection, Import products, Order placement, Mass management..."
      btn="Get Started" img="/static/imgs/product.svg" bg='top_bg_p' tlcontent='top_left_content_home'
      tlsymbol='top_left_symbol_home'></TopHP>
    <div class="product_about">
      <div class="product_about_box">
        <div class="product_about_line">
          <div class="product_about_line_img">
            <img src="/static/imgs/product2.png" alt="" />
          </div>
          <div class="product_about_line_text">
            <div class="product_about_line_text_img">
              <img src="../assets/product_ad.svg" alt="" />
            </div>
            <div class="product_about_line_text_content">
              <div class="product_about_line_text_content_title">ANTDIY is the dropshipping application of AliExpress
                official partners.</div>
              <div class="product_about_line_text_content_box">
                <em></em>
                <div>We have billions of high-quality best-selling products from AliExpress.</div>
              </div>
              <div class="product_about_line_text_content_box">
                <em></em>
                <div>You can import any product to the Shopify, Bigcommerce, Woocommerce store for sale with one-click.
                </div>
              </div>
              <div class="product_about_line_text_content_box">
                <em></em>
                <div>You can easily manage your stock, shipping and order data to grow your business.</div>
              </div>
            </div>
            <div class="product_about_button" @click="changeRouter('/antdiy')">
              <div class="product_about_button_text">
                Explore More Feature
              </div>
              <img class="product_about_button_img" src="../assets/product_arrow_right.svg" alt="">
            </div>
          </div>
        </div>
        <div class="product_about_line">
          <div class="product_about_line_img">
            <img src="/static/imgs/product3.png" alt="" />
          </div>
          <div class="product_about_line_text">
            <div class="product_about_line_text_img">
              <img src="../assets/product_af.svg" alt="">
            </div>
            <div class="product_about_line_text_content">
              <div class="product_about_line_text_content_box">
                <em></em>
                <div class="product_about_line_text_content_box_text1">ANTSUPPLY provides a one-stop dropshipping
                  solution for
                  large and medium-sized customers,
                  allowing them to
                  purchase cross-border products as easily and reliably as from local high-quality suppliers.</div>
              </div>
              <div class="product_about_line_text_content_box">
                <em></em>
                <div class="product_about_line_text_content_box_text2">ANTSUPPLY is directly connected to the 1688
                  platform and
                  overseas self-operated warehouses,
                  providing you
                  with access to billions of products.</div>
              </div>
            </div>
            <div class="product_about_button" @click="changeRouter('/antdiypro')">
              <div class="product_about_button_text">
                Explore More Feature
              </div>
              <img class="product_about_button_img" src="../assets/product_arrow_right.svg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="product_about_bg"></div>
    </div>
    <!-- <div class="product_antools">
      <div class="title_icon product_antools_symbol"></div>
      <div class="product_antools_title">ANTOOLS</div>
      <div class="product_antools_content">
        <div class="product_antools_content_box">
          <img src="../assets/icon_Crown.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Crown Trust Badge</div>
            <div class="product_antools_content_right_text">
              Set and show payment method to your customers on your store page.Design Choose your own locations Over 200 payment badges.
            </div>
          </div>
        </div>
        <div class="product_antools_content_box">
          <img src="../assets/icon_Star.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Star Review</div>
            <div class="product_antools_content_right_text">
              Import Reviews Importing Reviews From AliExpress within 1-Click.
            </div>
          </div>
        </div>
        <div class="product_antools_content_box">
          <img src="../assets/icon_Header.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Header Bar</div>
            <div class="product_antools_content_right_text">
              Design an Announcement Bar to your store by yourself easily.
            </div>
          </div>
        </div>
        <div class="product_antools_content_box">
          <img src="../assets/icon_Fa.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Fa Christmas Socks</div>
            <div class="product_antools_content_right_text">
              Customize coupon You can select the validation time and valid product range for this coupon.
            </div>
          </div>
        </div>
        <div class="product_antools_content_box">
          <img src="../assets/icon_Store.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Store Copy Duplicate & Replay</div>
            <div class="product_antools_content_right_text">
              Clone Everything of One Store to Another!
            </div>
          </div>
        </div>
        <div class="product_antools_content_box">
          <img src="../assets/icon_Smart.svg" alt="" />
          <div class="product_antools_content_right">
            <div class="product_antools_content_right_title">Smart Scanner</div>
            <div class="product_antools_content_right_text">
              Fix SEO Issues. Improve Store Rankings. Drive Organic Traffic!
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="procuct_antools">
      <div class="procuct_antools_box">
        <div class="procuct_antools_box_symbol"></div>
        <div class="procuct_antools_box_title">ANTOOLS</div>
        <div class="procuct_antools_line">
          <div class="procuct_antools_column">
            <div class="procuct_antools_circle"></div>
            <img class="procuct_antools_image" src="../assets/procuct_antools_1.svg">
            <div class="procuct_antools_title">Cart drawer</div>
            <div class="procuct_antools_text">When customer add product to cart, a drawer panel show contents of cart will slide out from right side of current page.</div>
          </div>
          <div class="procuct_antools_column">
            <div class="procuct_antools_circle"></div>
            <img class="procuct_antools_image" src="../assets/procuct_antools_2.svg">
            <div class="procuct_antools_title">Recently sales notice</div>
            <div class="procuct_antools_text">Show visitors what items other customers have purchased or added to carts from your store.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_3.svg">
            <div class="procuct_antools_title">Announcement bar</div>
            <div class="procuct_antools_text">Announcement bar is displayed on your store page header to notify visitors of some important information.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_4.svg">
            <div class="procuct_antools_title">Countdown timer</div>
            <div class="procuct_antools_text">Display a sales countdown timer in your store to increase customers tension.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_5.svg">
            <div class="procuct_antools_title">Stock countdown</div>
            <div class="procuct_antools_text">Let customers see shortage of inventory intuitively and place orders as soon as possible.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_6.svg">
            <div class="procuct_antools_title">CTA pop-ups</div>
            <div class="procuct_antools_text">Triggered by a specific event, a pop-up in your store requires visitors to subscribe to email or call to click.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_7.svg">
            <div class="procuct_antools_title">Wheel of fortune</div>
            <div class="procuct_antools_text">Invite customers to enter their email to participate in discount coupon lottery to capture more potential customers and boost conversion rate.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_8.svg">
            <div class="procuct_antools_title">Custom badge</div>
            <div class="procuct_antools_text">Add a service pledge badge on the product page, you can customize badge style and text content.</div>
          </div>
          <div class="procuct_antools_column">
            <img class="procuct_antools_image" src="../assets/procuct_antools_9.svg">
            <div class="procuct_antools_title">Pre-Orders</div>
            <div class="procuct_antools_text">Create a pre-order function for your store.</div>
          </div>
        </div>
        <div v-if="isMobileHome" class="procuct_antools_roll">
          <div v-for="index in 9" :key="index"
            :class="RollPointActive==index? 'procuct_antools_roll_point_active procuct_antools_roll_point':'procuct_antools_roll_point'">
          </div>
        </div>
        <div class="procuct_antools_bottom_text">Please look forward to more content…</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import TopHP from './common/topHP.vue'

export default {
  name: 'Products',
  components: {
    Header,
    Footer,
    TopHP
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      isMobileHome: false,
      RollPointActive: 1,
    }
  },
  created () {
    // this.enlargeSayList()
    if (document.body.offsetWidth > 767) {
      this.isMobileHome = false
    } else {
      this.isMobileHome = true
    }
  },
  mounted () {
    if (this.isMobileHome) {
      this.keyRoll();
    } else {
      // this.tabScroll();
    }
  },
  deactivated () {
    if (this.isMobileHome) {
      window.removeEventListener('scroll', this.keyRollChange, true)
    } else {
      // window.removeEventListener('scroll', this.handleScrollHome)
      // if (this.slideshow) {
      //   window.clearInterval(this.slideshow);
      // }
    }
  },
  methods: {
    changeRouter (link) {
      this.$router.push({
        path: link
      }).catch(err => {
        // console.log('e',err)
      })
    },
    keyRoll () {
      window.addEventListener('scroll', this.keyRollChange, true);
    },
    keyRollChange () {
      let keyLine = document.querySelector('.procuct_antools_line');
      let id = keyLine.scrollLeft / (keyLine.scrollWidth - keyLine.clientWidth) * 9;
      if (id > 9) {
        id =9;
      }
      this.RollPointActive = id == 0 ? 1 : Math.ceil(id);
    },
  }
}
</script>

<style scoped>
.product_about {
  width: 100%;
  background: #f6f7fa;
  position: relative;
  overflow: hidden;
}
.product_about_bg {
  position: absolute;
  top: 272px;
  left: calc(50% + 300px);
  width: 2000px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.79;
  border: 120px solid #ffffff;
}
.product_about_box {
  width: 1200px;
  margin: 0 auto;
  padding: 120px 0;
  position: relative;
  z-index: 1;
}
.product_about_line {
  display: flex;
  justify-content: space-between;
}
.product_about_line + .product_about_line {
  padding-top: 203px;
}
.product_about_line_img {
  width: 324px;
  height: 324px;
}
.product_about_line_img img {
  width: 324px;
  height: 324px;
}
.product_about_line_text {
  width: 786px;
}
.product_about_line_text_img img {
  height: 50px;
}
.product_about_line_text_content {
  margin-top: 44px;
}
.product_about_line_text_content div {
  font-size: 20px;
  font-family: Helvetica;
  color: #222536;
  line-height: 32px;
}
.product_about_line_text_content em {
  display: inline-block;
  width: 8px;
  height: 4px;
  background: #fc5421;
  border-radius: 2px;
  margin: 23px 8px 0 0;
  flex: 0 0 auto;
}
.product_about_line_text_content_title {
  margin-bottom: 10px;
}
.product_about_line_text_content_box {
  display: flex;
}
.product_about_line_text_content_box > div {
  margin-top: 10px;
}

.product_about_button {
  width: 231px;
  height: 48px;
  margin-top: 40px;
  background: #ffffff;
  box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
}
.product_about_button:hover {
  cursor: pointer;
  background: #fc5322;
}
.product_about_button:hover .product_about_button_text {
  color: #ffffff;
}
.product_about_button:hover .product_about_button_img {
  content: url(../assets/product_arrow_right_hover.svg);
}
.product_about_button_text {
  font-size: 16px;
  font-family: Helvetica;
  /* font-weight: bold; */
  color: rgba(0, 0, 0, 0.65);
}
.product_about_button_img {
  height: 16px;
  margin-left: 8px;
  flex: 0 0 auto;
}

/* .product_antools {
  width: 1200px;
  margin: 0 auto;
  padding: 120px 0 50px;
}
.product_antools_symbol {
  margin: 0 auto;
}
.product_antools_title {
  text-align: center;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin: 27px 0 47px;
}
.product_antools_content {
  display: flex;
  flex-wrap: wrap;
}
.product_antools_content_box {
  width: 50%;
  display: flex;
  padding-bottom: 70px;
}
.product_antools_content_box:nth-child(2n) {
  justify-content: flex-end;
}
.product_antools_content_box img {
  width: 80px;
  height: 80px;
}
.product_antools_content_right {
  width: 387px;
  margin-left: 20px;
}
.product_antools_content_right_title {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 20px;
  margin-top: 9px;
}
.product_antools_content_right_text {
  font-size: 16px;
  font-family: Helvetica;
  color: #222536;
  line-height: 24px;
  margin-top: 18px;
} */

.procuct_antools {
  background: #ffffff;
  margin-bottom: 100px;
}
.procuct_antools_box {
  width: 1200px;
  height: 1275px;
  margin: 0 auto;
}
.procuct_antools_box_symbol {
    width: 24px;
    height: 4px;
    background: #fc5421;
    border-radius: 2px;
    margin: 112px auto 27px;
}
.procuct_antools_box_title {
  padding: 0 0 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
  }
.procuct_antools_line {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* height: 217px; */
}
.procuct_antools_column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 386px;
  height: 325px;
  background: #ffffff;
  border: 1px solid #01C4C70a;
  border-radius: 20px;
  box-shadow: 0px 0px 13px 0px rgba(168,168,168,0.15);
  margin-bottom: 30px;
}
/* .procuct_antools_column:hover {
  box-shadow: 0px 10px 8px 0px rgba(156, 156, 156, 0.22),
    0px 5px 4px 0px rgba(167, 167, 167, 0.06);
} */
.procuct_antools_image {
  margin-top: 30px;
  height: 122px;
}
.procuct_antools_title {
  width: 255px;
  height: 28px;
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  text-align: center;
  line-height: 28px;
  margin-top: 22px;
}
.procuct_antools_text {
  width: 342px;
  height: 48px;
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  text-align: center;
  line-height: 24px;
  margin-top: 15px;
}
.procuct_antools_bottom_text {
  height: 40px;
  font-size: 20px;
  color: #222536;
  line-height: 40px;
  font-weight: 400;
  text-align: center;
}

@media (max-width: 767px) {
  /* .product_about{

  } */
  .product_about_box {
    width: 100%;
    padding: 0.77rem 0.46rem;
  }
  .product_about_line {
    flex-direction: column-reverse;
    position: relative;
  }
  .product_about_line_text {
    width: 100%;
  }
  .product_about_line_text_content {
    margin: 0.4rem 0 1rem;
    font-size: 0.3rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.42rem;
    /* text-align: justify; */
  }
  .product_about_line_text_content div {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.29rem;
  }
  .product_about_line_text_content em {
    display: inline-block;
    width: 0.15rem;
    height: 0.04rem;
    background: #fc5421;
    border-radius: 0.02rem;
    margin: 0.33rem 0.1rem 0 0;
    flex: 0 0 auto;
  }
  .product_about_line_text_content_title {
    margin-bottom: 0.1rem;
  }
  .product_about_line_text_content_box {
    display: flex;
  }
  .product_about_line_text_content_box > div {
    margin-top: 0.2rem;
  }
  .product_about_line_text_content_box_text1,
  .product_about_line_text_content_box_text2 {
    font-size: 0.3rem;
    line-height: 0.36rem;
  }
  .product_about_line_text_content_box_text1 {
    margin-bottom: 0.1rem;
  }
  .product_about_button {
    width: 100%;
    height: 0.96rem;
    margin-top: 0.4rem;
    background: #ffffff;
    box-shadow: 0 0.06rem 0.08rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.08rem;
    border: 0.01rem solid rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 50%;
    bottom: 1rem;
    transform: translate(-50%, 0);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product_about_button_text {
    font-size: 0.28rem;
    font-family: Helvetica-Blod, Helvetica;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.65);
  }
  .product_about_button_img {
    height: 0.24rem;
    margin-left: 8px;
    flex: 0 0 auto;
  }

  .product_about_line_img {
    width: 100%;
    height: auto;
    margin-bottom: 2.36rem;
  }
  .product_about_line_img img {
    width: 100%;
    height: 100%;
  }
  .product_about_bg {
    display: none;
  }
  .product_about_line + .product_about_line {
    padding-top: 0;
  }
  /* .product_antools {
    width: 100%;
    padding: 1rem 0.46rem 1.15rem;
  }
  .product_antools_symbol {
    margin: 0;
  }
  .product_antools_title {
    margin: 0.39rem 0 0.61rem;
    text-align: left;
    font-size: 0.46rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.58rem;
  }
  .product_antools_content {
    flex-direction: column;
  }
  .product_antools_content_box {
    width: 100%;
    flex-direction: column;
    padding: 0;
  }
  .product_antools_content_box + .product_antools_content_box {
    margin-top: 0.61rem;
  }
  .product_antools_content_box > img {
    width: 1.15rem;
    height: 1.15rem;
  }
  .product_antools_content_right {
    width: 100%;
    margin: 0;
  }
  .product_antools_content_right_title {
    margin: 0.28rem 0 0.19rem;
    font-size: 0.29rem;
    font-family: Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.29rem;
  }
  .product_antools_content_right_text {
    font-size: 0.29rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.4rem;
    margin: 0;
  } */
  .product_about_line_text_img > img {
    height: 0.75rem;
  }

  .procuct_antools {
    background: #ffffff;
  }
  .procuct_antools_box {
    width: 100%;
    height: auto;
    margin: 0.64rem auto 0;
    padding: 0.7rem 0.48rem 0;
  }
  .procuct_antools_box_symbol {
    display: none;
  }
  .procuct_antools_box_title {
    height: 0.48rem;
    padding: 0;
    margin-bottom: 0.71rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.48rem;
  }
  .procuct_antools_line {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: auto;
    overflow: auto;
  }
  .procuct_antools_line::-webkit-scrollbar {
    /* 组件内滚动条不显示 */
    display: none;
  }
  .procuct_antools_column {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 3.86rem;
    height: 3.25rem;
    background: #ffffff;
    border: 1px solid #01C4C70a;
    border-radius: 0.2rem;
    box-shadow: 0px 0px 0.13rem 0px rgba(168,168,168,0.15);
    margin: 0.1rem 0 0.1rem 0.2rem;
  }
  /* .procuct_antools_column:hover {
    box-shadow: 0 0.1rem 0.08rem 0 rgba(156, 156, 156, 0.22),
      0 0.05rem 0.04rem 0 rgba(167, 167, 167, 0.06);
  } */
  .procuct_antools_image {
    margin-top: 0.3rem;
    height: 1.22rem;
  }
  .procuct_antools_title {
    width: 3.3rem;
    height: auto;
    font-size: 0.24rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    text-align: center;
    line-height: 0.28rem;
    margin-top: 0.2rem;
    /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
  }
  .procuct_antools_text {
    width: 3.42rem;
    height: auto;
    font-size: 0.2rem;
    font-family: Helvetica;
    color: #8d919b;
    text-align: center;
    line-height: 0.24rem;
    margin-top: 0.15rem;
    padding: 0 0.2rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .procuct_antools_roll {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.19rem 0 0.8rem;
  }
  .procuct_antools_roll_point {
    width: 0.12rem;
    height: 0.12rem;
    background: #fc5322;
    border-radius: 50%;
    opacity: 0.14;
    display: inline-block;
    transition: all .2s;
  }
  .procuct_antools_roll_point + .procuct_antools_roll_point {
    margin-left: 0.2rem;
  }
  .procuct_antools_roll_point_active {
    width: 0.14rem;
    height: 0.14rem;
    border-radius: 50%;
    opacity: 1;
  }
  .procuct_antools_bottom_text {
    height: 0.4rem;
    font-size: 0.2rem;
    color: #222536;
    line-height: 0.4rem;
    font-weight: 400;
    margin-top: 0.2rem;
  }
}
</style>
<style>
.top_bg_p {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.55;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 27px;
  left: -636px;
}
.top_left_content_product {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 20px;
  margin-bottom: 19px;
  display: flex;
  align-items: flex-start;
}
.top_left_symbol_product {
  margin: 63px 0 21px;
}

@media (max-width: 767px) {
  .top_bg_p {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product.vue